import { FeatureURI } from '@sbt-web/network/types';
import { isShippable } from '@sbt-web/utils';

const getBadgeConfiguration = (ad, display) => ({
    display,
    shippable: isShippable(ad),
    isItemSold: !!ad.features[FeatureURI.TransactionStatus],
});

export { getBadgeConfiguration };
//# sourceMappingURL=getBadgeConfiguration.js.map
